<template>
  <div class="row card borderless-card ml-0 mr-0" style="box-shadow:none">
    <div class="row ml-0 mr-0 mt-3">
      <div class="d-flex" style="height: 40px;">
        <div
          v-if="selectedTeamMembers && selectedTeamMembers.length > 0"
          class="teamSelectedChildDiv"
        >
          <span class="mr-4">{{selectedTeamMembers.length}} Member Selected</span>
          <i class="fas fa-envelope mr-3 mt-1 handCls" v-if="checkBulkEmail" @click="SendBulkEmail"></i>
          <i class="fas fa-trash-alt mr-3 mt-1 handCls" v-if="checkTeamDelete" @click="bulkDelete"></i>
        </div>
      </div>
    </div>
    <div v-if="teams && teams.length > 0">
      <div class="d-flex mt-2" style="flex-wrap: wrap;">
        <div
          v-for="(item,index) in teams"
          :key="index"
          :class="(hoverTeamIndex == index) || item.isChecked ?'mb-0 teamCardCls teamCardHover':'mb-0 teamCardCls'"
          @mouseover="hoverTeamIndex=index"
          @mouseleave="hoverTeamIndex=-1"
        >
          <div class="team-top-parent" v-if="!(item.roleName == 'Owner' && checkOwner)">
            <input
              type="checkbox"
              class="regular-checkbox teamCheckBoxCls handCls"
              v-model="item.isChecked"
              @change="selectMethod(item,item.isChecked)"
              :style="(hoverTeamIndex == index) || item.isChecked ?'display:block':'display:none'"
            />
          </div>
          <div class="teamImageCls">
            <img
              v-if="item.image && item.image.length > 0"
              :src="item.image"
              :id="'teamPopover'+item._id+index"
              style="min-width:100%;min-height:100%;border-radius:50%"
            />
            <b-avatar
              v-else
              :text="item.name.charAt(0).toUpperCase()"
              class="align-baseline referrerAvatar"
              :id="'teamPopover'+item._id+index"
              :style="`background:${pickBackgroundColor(item.name)};min-width:100%;min-height:100%;border-radius:50%;cursor:pointer`"
            ></b-avatar>
            <b-popover :target="'teamPopover'+item._id+index" triggers="hover" placement="topright">
              <div class="popoverNameCls">{{item.name}}</div>
              <div style="color: #00000080;font-size: 12px;" v-if="item.roleName">{{item.roleName}}</div>
              <div style="color: #00000080;font-size: 12px;" v-if="item.email">{{item.email}}</div>
              <div class="d-flex">
                <div
                  v-if="item.invested && item.invested.length"
                  class="mr-2"
                >Invested - {{item.invested.length}}</div>
                <div
                  v-if="item.referred && item.referred.length"
                  class="mr-2"
                >Referred - {{item.referred.length}}</div>
                <div
                  v-if="item.rejected && item.rejected.length"
                  class="mr-2"
                >Passed - {{item.rejected.length}}</div>
              </div>
            </b-popover>
          </div>
          <div>
            <div class="userNameCls" :title="item.name">{{item.name}}</div>
            <div class="otherDetailsCls">{{item.roleName}}</div>
            <div class="otherDetailsCls" :title="item.email">{{item.email}}</div>
          </div>
          <div class="d-flex mt-2" style="justify-content: center;">
            <!-- v-if="item.invested && item.invested.length > 0" -->

            <div
              style="color: #5445F3;cursor:pointer"
              :id="'invstTeamCompPopover'+item._id+index"
              v-if="item.rot > 0"
            >Invested {{item.invested?item.invested.length:0}} of {{item.rot}}</div>
            <b-popover
              :target="'invstTeamCompPopover'+item._id+index"
              triggers="hover"
              placement="topright"
            >
              <div v-for="(item,index) in item.invested" :key="index">
                <div @click="navigate(item)" class="popOverCompany">{{item.name}}</div>
              </div>
            </b-popover>
            <!-- <div
              class="teamPill px-2"
              v-if="item.referred && item.referred.length > 0"
              style=" border: 1px solid #7E7E7E;"
              :id="'refTeamCompPopover'+item._id+index"
            >{{item.referred?item.referred.length:0}} Referred</div>
            <b-popover
              :target="'refTeamCompPopover'+item._id+index"
              triggers="hover"
              placement="topright"
            >
              <div v-for="(refItem,index) in item.referred" :key="index">
                <div @click="navigate(refItem)" class="popOverCompany">{{refItem.name}}</div>
              </div>
            </b-popover>-->
          </div>
          <div
            class="d-flex mt-3"
            style="justify-content: center;margin-bottom:15px"
            v-if="((hoverTeamIndex == index) || item.isChecked) && !(item.roleName == 'Owner' && checkOwner)"
          >
            <i
              class="fas fa-envelope mr-3 handCls"
              v-if="item.email && item.email.length > 0 && checkTeamEmail"
              @click="handleSendEmail(item)"
            ></i>
            <i
              class="fas fa-pencil-alt mr-3 handCls"
              v-if="checkTeamEdit && !(item.roleName == 'Owner')"
              @click="handleEditTeamMember(item)"
            ></i>
            <i
              class="fas fa-trash-alt handCls"
              v-if="checkTeamDelete && !(item.roleName == 'Owner')"
              @click="handleDelete(item,'Team')"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      style="color:#00000080;margin-bottom:15px"
    >You don't have any team members in this workspace.</div>
    <div>
      <div style="font-size:16px">Referrer</div>
      <div v-if="referrers && referrers.length > 0">
        <div class="d-flex mt-2" style="flex-wrap: wrap;">
          <div
            v-for="(item,index) in referrers"
            :key="index"
            :class="(hoverReferrerIndex == index) || item.isChecked ?'mb-0 teamCardCls teamCardHover':'mb-0 teamCardCls'"
            @mouseover="hoverReferrerIndex=index"
            @mouseleave="hoverReferrerIndex=-1"
          >
            <div class="team-top-parent">
              <input
                type="checkbox"
                class="regular-checkbox teamCheckBoxCls handCls"
                v-model="item.isChecked"
                v-if="item.email && item.email.length > 0"
                @change="selectMethod(item,item.isChecked)"
                :style="(hoverReferrerIndex == index) || item.isChecked ?'display:block':'display:none'"
              />
            </div>
            <div class="teamImageCls">
              <b-avatar
                :text="item.name.charAt(0).toUpperCase()"
                class="align-baseline referrerAvatar"
                :id="'referrerPopover'+item._id+index"
                :style="`background:${pickBackgroundColor(item.name)};min-width:100%;min-height:100%;border-radius:50%;cursor:pointer`"
              ></b-avatar>
              <b-popover
                :target="'referrerPopover'+item._id+index"
                triggers="hover"
                placement="topright"
              >
                <div class="popoverNameCls">{{item.name}}</div>
                <div style="color: #00000080;font-size: 12px;" v-if="item.email">{{item.email}}</div>
                <div class="d-flex">
                  <div
                    v-if="item.invested && item.invested.length"
                    class="mr-2"
                  >Invested - {{item.invested.length}}</div>
                  <div
                    v-if="item.referred && item.referred.length"
                    class="mr-2"
                  >Referred - {{item.referred.length}}</div>
                  <div
                    v-if="item.rejected && item.rejected.length"
                    class="mr-2"
                  >Passed - {{item.rejected.length}}</div>
                </div>
              </b-popover>
            </div>
            <div>
              <div class="userNameCls" :title="item.name">{{item.name}}</div>
              <div class="otherDetailsCls">{{item.roleName}}</div>
              <div class="otherDetailsCls" :title="item.email">{{item.email}}</div>
            </div>
            <div class="d-flex mt-2" style="justify-content: center;">
              <div
                style="color: #5445F3;cursor:pointer"
                :id="'invstReferrerCompPopover'+item._id+index"
                v-if="item.rot > 0"
              >Invested {{item.invested.length}} of {{item.rot}}</div>
              <b-popover
                :target="'invstReferrerCompPopover'+item._id+index"
                triggers="hover"
                placement="topright"
              >
                <div v-for="(item,index) in item.invested" :key="index">
                  <div @click="navigate(item)" class="popOverCompany">{{item.name}}</div>
                </div>
              </b-popover>
              <!-- <div
                class="teamPill px-2"
                style=" border: 1px solid #7E7E7E;"
                :id="'refReferrerCompPopover'+item._id+index"
                v-if="item.referred && item.referred.length > 0"
              >{{item.referred.length}} Referred</div>
              <b-popover
                :target="'refReferrerCompPopover'+item._id+index"
                triggers="hover"
                placement="topright"
              >
                <div v-for="(refItem,index) in item.referred" :key="index">
                  <div @click="navigate(refItem)" class="popOverCompany">{{refItem.name}}</div>
                </div>
              </b-popover>-->
            </div>
            <div
              class="d-flex mt-3"
              style="justify-content: center;margin-bottom:15px"
              v-if="(hoverReferrerIndex == index) || item.isChecked"
            >
              <i
                class="fas fa-envelope mr-3 handCls"
                v-if="item.email && item.email.length > 0 && checkReferrerEmail"
                @click="handleSendEmail(item)"
              ></i>
              <i
                class="fas fa-pencil-alt mr-3 handCls"
                v-if="checkReferrerEdit"
                @click="handleEditReferrerMember(item)"
              ></i>
              <i
                class="fas fa-trash-alt mr-3 handCls"
                v-if="checkReferrerEdit"
                @click="handleDelete(item,'Referrer')"
              ></i>
              <img
                v-if="item.email && item.email.length > 0 && (count.accountUsersCount+1)<count.usersCount && showTeamButton && checkAddReferrerasTeam"
                @click="inviteReferrerTeam(item)"
                src="static/img/addReferrer.svg"
                class
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        style="color:#00000080;margin-bottom:15px"
      >You don't have referrers in this workspace.</div>
    </div>
    <el-dialog
      center
      title="Really Delete?"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="750px"
      style="margin: 0 auto;"
      :visible.sync="confirmMdlShow"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="card-body">
        <div class="inputs row">
          <p
            style="width: 100%; text-align: center;"
          >Are you sure you want to delete this user? This can't be undone.</p>
        </div>
        <div class="actionbuttons">
          <button
            @click.prevent="handleCancel"
            class="todo-form-cancel-button btn-outline-secondary"
          >Cancel</button>
          <button
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px;"
            :disabled="submitted"
            @click="deleteMethod"
          >
            Yes
            <b-spinner v-if="submitted" small label="Spinning"></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <DialogEditTeam v-model="dialogEditTeam"></DialogEditTeam>
    <DialogSendEmail @emit-sucess="emitSuccess" v-model="dialogSendEmail"></DialogSendEmail>
    <DialogInviteTeam
      v-if="teamModalShow"
      @user-success="$emit('user-success', {})"
      v-model="dialogTeamData"
      :roles="roles"
    ></DialogInviteTeam>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import { Select, Option, Dialog } from "element-ui";
import DialogEditTeam from "../Dialogs/DialogEditTeam";
import DialogSendEmail from "../Dialogs/DialogSendEmail";
import { pickBackgroundColor } from "../../../util/index";
import DialogInviteTeam from "../Dialogs/DialogInviteTeam";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    DialogEditTeam,
    DialogSendEmail,
    DialogInviteTeam,
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("referrer", ["referrerMembers"]),
    ...mapGetters("referrer", ["teamMembers"]),
    ...mapGetters("portfolio", ["portfolioAll"]),
    ...mapGetters("workspacePlans", ["feature", "plan"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    showTeamButton() {
      let featureIndex = this.feature.findIndex((item) => {
        if (item == "CREATE_USER") return item;
      });
      if (featureIndex >= 0) return true;
      else return false;
    },
    checkTeamEmail() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "EMAIL TEAM MEMBER") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    checkTeamEdit() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "EDIT TEAM MEMBER") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    checkTeamDelete() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "DELETE TEAM MEMBER") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    checkAddReferrerasTeam() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "ADD REFERRER AS TEAM") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    checkBulkEmail() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "BULK EMAIL") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    checkReferrerEdit() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "EDIT REFERRER") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    checkReferrerEmail() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "EMAIL REFERRER") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    referrers() {
      let self = this;
      let data =
        this.referrerMembers.length > 0
          ? JSON.parse(JSON.stringify(this.referrerMembers))
          : [];
      data.map((item) => {
        item.isChecked = false;
        item.invested.map((investItem) => {
          if (investItem.portfolio_item) {
            let portfolioItem = self.portfolioAll.find(
              (obj) => obj._id == investItem.portfolio_item
            );
            if (portfolioItem) {
              investItem.name = portfolioItem.name;
              investItem.logo_url = portfolioItem.logo_url;
              investItem.ucid = portfolioItem.ucid;
            }
          }
        });
        item.rot =
          item.invested.length + item.rejected.length + item.referred.length;
      });
      return data;
    },
    teams() {
      let data =
        this.teamMembers.length > 0
          ? JSON.parse(JSON.stringify(this.teamMembers))
          : [];
      data.map((item) => {
        item.isChecked = false;
        item.rot =
          item.invested.length + item.rejected.length + item.referred.length;
      });
      return data;
    },
    checkOwner() {
      let index = this.teams.findIndex((item) =>
        item.account && item.account._id
          ? item.account._id == this.$route.params.account_id
          : -1
      );
      if (
        index >= 0 &&
        this.teams[index] &&
        this.teams[index].role &&
        this.teams[index].role.name == "Owner"
      )
        return true;
      else return false;
    },
  },
  props: {
    roles: {
      type: Array,
      default() {
        return [];
      },
    },
    count: {
      type: Object,
    },
  },
  mounted() {},
  watch: {},
  data() {
    return {
      hoverTeamIndex: -1,
      hoverReferrerIndex: -1,
      modalForm: false,
      dialogEditTeam: {
        isShow: false,
        title: "",
        data: {},
        roles: [],
      },
      dialogTeamData: {
        isShow: false,
        isReferrer: false,
        data: {},
        isCreate: true,
      },
      dialogSendEmail: {
        isShow: false,
        data: {},
      },
      confirmMdlShow: false,
      submitted: false,
      teamMember: {},
      deleteItem: {},
      selectedTeamMembers: [],
      bulkSelected: false,
      teamModalShow: false,
    };
  },
  methods: {
    pickBackgroundColor: pickBackgroundColor,
    handleSendEmail(item) {
      let emails = item.email && item.email.length > 0 ? [item.email] : "";
      if (emails.length > 0) {
        this.dialogSendEmail = {
          isShow: true,
          data: { emails, component: "Teams" },
        };
      }
    },
    bulkDelete() {
      this.bulkSelected = true;
      this.confirmMdlShow = true;
    },
    inviteReferrerTeam(item) {
      this.teamModalShow = true;
      this.dialogTeamData = {
        isShow: true,
        isCreate: true,
        isReferrer: true,
        data: {
          referrer: item._id,
          email: item.email,
        },
        isCreate: true,
      };
    },
    navigate(item) {
      let self = this;
      if (item.ucid) {
        self.$store.commit("temp/currentCompany", item.ucid);
        self.$router.push(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${item.ucid}`
        );
      }
    },
    SendBulkEmail() {
      if (this.selectedTeamMembers.length > 0) {
        let emails = [];
        this.selectedTeamMembers.map((item) => {
          if (item.email) emails.push(item.email);
        });
        this.dialogSendEmail = {
          isShow: true,
          data: { emails, component: "Teams" },
        };
      }
    },
    emitSuccess() {
      this.selectedTeamMembers = [];
      this.referrers.map((item) => {
        item.isChecked = false;
      });
      this.teams.map((item) => {
        item.isChecked = false;
      });
    },
    handleCancel() {
      this.confirmMdlShow = false;
      this.submitted = false;
      this.teamMember = {};
      this.deleteItem = {};
    },
    handleEditReferrerMember(item) {
      this.dialogEditTeam = {
        isShow: true,
        title: "Edit Referrer",
        data: JSON.parse(JSON.stringify(item)),
        roles: [],
      };
    },
    handleEditTeamMember(item) {
      this.dialogEditTeam = {
        isShow: true,
        title: "Edit Role",
        data: JSON.parse(JSON.stringify(item)),
        roles: this.roles,
      };
    },
    selectMethod(item, check) {
      if (check) this.selectedTeamMembers.push(item);
      else {
        let index = this.selectedTeamMembers.findIndex(
          (users) => users._id == item._id
        );
        if (index >= 0) this.selectedTeamMembers.splice(index, 1);
      }
    },
    handleDelete(item, entity) {
      this.bulkSelected = false;
      this.entity = entity;
      this.deleteItem = item;
      this.confirmMdlShow = true;
    },
    removeDeleteCheck() {
      let index = this.selectedTeamMembers.findIndex(
        (users) => users._id == this.deleteItem._id
      );
      if (index >= 0) this.selectedTeamMembers.splice(index, 1);
      this.deleteItem = {};
    },
    deleteMethod() {
      this.submitted = true;
      if (this.deleteItem && !this.bulkSelected) {
        let url = "";
        let data = {};
        if (this.entity == "Team") {
          url = "team/apiSoftDelete";
          data = {
            account:
              this.deleteItem.account && this.deleteItem.account._id
                ? this.deleteItem.account._id
                : "",
            workspace: this.$route.params.workspace_id,
            id: this.deleteItem._id,
          };
        } else {
          url = "referrer/apiDeleteReferrer";
          data = this.deleteItem._id;
        }
        this.$store
          .dispatch(url, data)
          .then((data) => {
            if (this.entity == "Team") {
              this.$emit("user-success", {});
              this.$store.commit("referrer/remove", this.deleteItem._id);
            }
            if (this.deleteItem && this.deleteItem.isChecked)
              this.removeDeleteCheck();
            else this.deleteItem = {};
            this.submitted = false;
            this.deleteItem = {};
            this.$toaster.success("Deleted successfully.");
            this.confirmMdlShow = false;
          })
          .catch((err) => {
            this.confirmMdlShow = false;
            this.submitted = false;
            this.$toaster.error("Fail to delete.");
          });
      } else if (
        this.bulkSelected &&
        this.selectedTeamMembers &&
        this.selectedTeamMembers.length > 0
      ) {
        let teamPayload = {
          account: [],
          id: [],
          workspace: this.$route.params.workspace_id,
        };
        let referrerPayload = [];
        this.selectedTeamMembers.map((item) => {
          if (item.isTeam) {
            if (item.account && item.account._id)
              teamPayload.account.push(item.account._id);
            if (item._id) teamPayload.id.push(item._id);
          } else {
            referrerPayload.push(item._id);
          }
        });
        this.$store
          .dispatch("referrer/apiBulkDeleteReferrer", referrerPayload)
          .then((data) => {
            this.$store
              .dispatch("team/apiBulkSoftDelete", teamPayload)
              .then((data) => {
                teamPayload.id.map((item) => {
                  this.$store.commit("referrer/remove", item);
                });
                this.$emit("user-success", {});
                this.emitSuccess();
                this.confirmMdlShow = false;
                this.submitted = false;
              });
          });
      }
    },
  },
};
</script>
<style >
.teamSelectedChildDiv {
  background: #f3f2fc 0% 0% no-repeat padding-box;
  border-radius: 8px;
  padding-top: 7px;
  padding-left: 15px;
}

.teamCardCls {
  width: 200px;
  height: 250px;
  text-align: center;
  margin-right: 15px;
  margin-bottom: 15px !important;
}

.teamCardHover {
  background: #f3f2fc 0% 0% no-repeat padding-box;
  /* border: 1px solid #f3f2fc; */
  border-radius: 4px;
  transition: all 0.3s ease;
}

.otherDetailsCls {
  color: #00000080;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 3px;
  text-overflow: ellipsis;
}

.teamImageCls {
  width: 90px;
  height: 90px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
}

.teamCheckBoxCls {
  cursor: pointer;
  margin-top: 15px;
  margin-left: 15px;
}
.team-top-parent {
  position: absolute;
  flex-direction: row;
}

.handCls {
  cursor: pointer !important;
}
.referrerAvatar .b-avatar-text {
  font-size: 30px !important;
  color: #000000;
}
.teamPill {
  border-radius: 10px;
  height: 20px;
  font-size: 12px;
  cursor: pointer !important;
}

.popoverNameCls {
  text-transform: capitalize;
  font-size: 14px;
  line-height: 20px;
  color: #000000cc;
}

.popOverCompany {
  color: #593bfd !important;
  cursor: pointer !important;
}
</style>